import React, { Component } from 'react';
import {
  Badge,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table } from 'reactstrap';

class Applications extends Component {
  render() {
    return (
      <div className="page-applications">
        <Container fluid>

          <Row className="mb-3 align-items-center">
            <Col md={6}>
              <h3 className="mb-3 mb-md-0 text-center text-md-left">Application Review</h3>
            </Col>

            <Col md={6}>
              <Form>
                <Row form>

                  <Col md={6} className="mb-1 mb-md-0">
                    <FormGroup className="dropdown-toggle mb-0 input-inline">
                      <Input type="select" name="select" id="applicationStatus">
                        <option value="">All Applications</option>
                        <option value="Approved">Approvals</option>
                        <option value="Pre-Approved">Pre-Approved</option>
                        <option value="Pending">Pending</option>
                        <option value="Need Signature">Need Signatures</option>
                        <option value="Approved - Doc%%in">Approved - Docs In</option>
                        <option value="Funded">Funded Applications</option>
                        <option value="Need Complete Application">Need Complete Application</option>
                        <option value="Canceled">Canceled</option>
                        <option value="Declined">Declined</option>
                        <option value="15DExp">Approvals Due to Expire</option>
                        <option value="Expired">Expired</option>
                        <option value="Not Qualified">Not Qualified</option>
                        <option value="Closed">Closed Applications</option>
                        <option value="Countered">Countered Applications</option>
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md={6}>
                    <FormGroup className="mb-0 input-inline">
                      <Input type="text" name="search" id="searchField" placeholder="Search" />
                    </FormGroup>
                  </Col>

                </Row>
              </Form>
            </Col>

          </Row>
          <Row>

            <Col>
              <Card>
                <CardHeader className="text-md-left">All Applications</CardHeader>

                <Table className="mb-0" size="sm" responsive striped borderless hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Status</th>
                      <th>Submitted</th>
                      <th>Applicant</th>
                      <th><span className="text-nowrap">Max. Approval</span></th>
                      <th><span className="text-nowrap">Amt. Financed</span></th>
                      <th><span className="text-nowrap">Payout %</span></th>
                      <th><span className="text-nowrap">Payout Amt.</span></th>
                      <th><span className="text-nowrap">Funded Date</span></th>
                      <th><span className="text-nowrap">Int. Rate</span></th>
                      <th><span className="text-nowrap">Monthly Pmt.</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15614</th>
                      <td><Badge color="success" className="w-100">Approved</Badge></td>
                      <td>04/04/2018</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>93%</td>
                      <td>$5,022.00</td>
                      <td>04/05/2018</td>
                      <td>11.99%</td>
                      <td>$129.70</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15613</th>
                      <td><Badge color="dark" className="w-100">Delcined</Badge></td>
                      <td>04/01/2018</td>
                      <td><span className="text-nowrap">Celine Gislason</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15612</th>
                      <td><Badge color="primary" className="w-100">Initiated</Badge></td>
                      <td>03/28/2018</td>
                      <td><span className="text-nowrap">Tiana Nitzsche</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15611</th>
                      <td><Badge color="success" className="w-100 outline">Pre-Approved</Badge></td>
                      <td>03/28/2018</td>
                      <td><span className="text-nowrap">Vida Toy</span></td>
                      <td>$4,100.00</td>
                      <td><span className="text-nowrap">No Selection</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15613</th>
                      <td><Badge color="warning" className="w-100">Pending</Badge></td>
                      <td>03/26/2018</td>
                      <td><span className="text-nowrap">Celine Gislason</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15614</th>
                      <td><Badge color="secondary" className="w-100">Expired</Badge></td>
                      <td>03/21/2018</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$8,500.00</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15613</th>
                      <td><Badge color="info" className="w-100">Needs Sig.</Badge></td>
                      <td>03/20/2018</td>
                      <td><span className="text-nowrap">Celine Gislason</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15614</th>
                      <td><Badge color="success" className="w-100">Approved</Badge></td>
                      <td>04/04/2018</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$5,200.00</td>
                      <td>$5,200.00</td>
                      <td>93%</td>
                      <td>$5,022.00</td>
                      <td>04/05/2018</td>
                      <td>11.99%</td>
                      <td>$129.70</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15613</th>
                      <td><Badge color="dark" className="w-100">Delcined</Badge></td>
                      <td>04/01/2018</td>
                      <td><span className="text-nowrap">Celine Gislason</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15612</th>
                      <td><Badge color="primary" className="w-100">Initiated</Badge></td>
                      <td>03/28/2018</td>
                      <td><span className="text-nowrap">Tiana Nitzsche</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15611</th>
                      <td><Badge color="success" className="w-100 outline">Pre-Approved</Badge></td>
                      <td>03/28/2018</td>
                      <td><span className="text-nowrap">Vida Toy</span></td>
                      <td>$4,100.00</td>
                      <td><span className="text-nowrap">No Selection</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15613</th>
                      <td><Badge color="warning" className="w-100">Pending</Badge></td>
                      <td>03/26/2018</td>
                      <td><span className="text-nowrap">Celine Gislason</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15614</th>
                      <td><Badge color="secondary" className="w-100">Expired</Badge></td>
                      <td>03/21/2018</td>
                      <td><span className="text-nowrap">Jordyn Bashirian</span></td>
                      <td>$8,500.00</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                    <tr className="clickable-row" onClick={() => window.open('/application/detail', '_self')}>
                      <th scope="row">15613</th>
                      <td><Badge color="info" className="w-100">Needs Sig.</Badge></td>
                      <td>03/20/2018</td>
                      <td><span className="text-nowrap">Celine Gislason</span></td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                      <td>—</td>
                    </tr>
                  </tbody>
                </Table>

              </Card>
            </Col>

          </Row>
          <Row className="mb-md-3">

            <Container fluid>
              <Row className="align-items-center">
                <Col md={{ size: 4, offset: 4 }}>
                  <Pagination aria-label="Page">
                    <PaginationItem disabled>
                      <PaginationLink previous href="#" />
                    </PaginationItem>
                    <PaginationItem active>
                      <PaginationLink href="#">1</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink href="#">2</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink href="#">3</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink href="#">4</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink href="#">5</PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink next href="#" />
                    </PaginationItem>
                  </Pagination>
                </Col>
                <Col md={4} className="text-center text-md-right mt-1 mt-md-0">
                  <small>1–20 of 123 entries</small>
                </Col>
              </Row>
            </Container>

          </Row>
        </Container>
      </div>
    )
  }
}

export default Applications;
